/*!
 * @license MIT
 * newrelic-video-videojs 0.3.1
 * Copyright New Relic <http://newrelic.com/>
 * @author Jordi Aguilar
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nrvideo"] = factory();
	else
		root["nrvideo"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.Core = exports.VideoTrackerState = exports.VideoTracker = exports.Tracker = exports.Emitter = exports.Log = exports.Chrono = exports.Constants = undefined;

var _core = __webpack_require__(10);

var _core2 = _interopRequireDefault(_core);

var _constants = __webpack_require__(11);

var _constants2 = _interopRequireDefault(_constants);

var _chrono = __webpack_require__(3);

var _chrono2 = _interopRequireDefault(_chrono);

var _log = __webpack_require__(2);

var _log2 = _interopRequireDefault(_log);

var _emitter = __webpack_require__(4);

var _emitter2 = _interopRequireDefault(_emitter);

var _tracker = __webpack_require__(5);

var _tracker2 = _interopRequireDefault(_tracker);

var _videotracker = __webpack_require__(12);

var _videotracker2 = _interopRequireDefault(_videotracker);

var _videotrackerstate = __webpack_require__(7);

var _videotrackerstate2 = _interopRequireDefault(_videotrackerstate);

var _package = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Constants = _constants2.default;
exports.Chrono = _chrono2.default;
exports.Log = _log2.default;
exports.Emitter = _emitter2.default;
exports.Tracker = _tracker2.default;
exports.VideoTracker = _videotracker2.default;
exports.VideoTrackerState = _videotrackerstate2.default;
exports.Core = _core2.default;
exports.version = _package.version;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newrelicVideoCore = __webpack_require__(0);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _package = __webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideojsAdsTracker = function (_nrvideo$VideoTracker) {
  _inherits(VideojsAdsTracker, _nrvideo$VideoTracker);

  function VideojsAdsTracker() {
    _classCallCheck(this, VideojsAdsTracker);

    return _possibleConstructorReturn(this, (VideojsAdsTracker.__proto__ || Object.getPrototypeOf(VideojsAdsTracker)).apply(this, arguments));
  }

  _createClass(VideojsAdsTracker, [{
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'videojs-ads';
    }
  }, {
    key: 'getTrackerVersion',
    value: function getTrackerVersion() {
      return _package.version;
    }
  }, {
    key: 'isMuted',
    value: function isMuted() {
      return this.player.muted();
    }
  }, {
    key: 'getRenditionHeight',
    value: function getRenditionHeight() {
      return null;
    }
  }, {
    key: 'getRenditionWidth',
    value: function getRenditionWidth() {
      return null;
    }
  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return 'videojs-ads';
    }
  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return this.player.ads.VERSION;
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      nrvideo.Log.debugCommonVideoEvents(this.player, [null, 'ads-request', 'ads-load', 'adstart', 'adend', 'adskip', 'adserror', 'ads-click', 'ads-pod-started', 'ads-pod-ended', 'ads-first-quartile', 'ads-midpoint', 'ads-third-quartile', 'ads-pause', 'ads-play', 'adtimeout']);

      // Register listeners
      this.player.on('ads-request', this.onAdrequest.bind(this));
      this.player.on('ads-load', this.onAdload.bind(this));
      this.player.on('adstart', this.onAdstart.bind(this));
      this.player.on('adend', this.onAdend.bind(this));
      this.player.on('adskip', this.onAdskip.bind(this));
      this.player.on('adserror', this.onAdserror.bind(this));
      this.player.on('ads-click', this.onAdsClick.bind(this));
      this.player.on('ads-pod-started', this.onPodStart.bind(this));
      this.player.on('ads-pod-ended', this.onPodEnd.bind(this));
      this.player.on('ads-first-quartile', this.onFirstQuartile.bind(this));
      this.player.on('ads-midpoint', this.onMidpoint.bind(this));
      this.player.on('ads-third-quartile', this.onThirdQuartile.bind(this));
      this.player.on('ads-pause', this.onAdspause.bind(this));
      this.player.on('ads-play', this.onAdsplay.bind(this));
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      // unregister listeners
      this.player.off('ads-request', this.onAdrequest);
      this.player.off('ads-load', this.onAdload);
      this.player.off('adstart', this.onAdstart);
      this.player.off('adend', this.onAdend);
      this.player.off('adskip', this.onAdskip);
      this.player.off('adserror', this.onAdserror);
      this.player.off('ads-click', this.onAdsClick);
      this.player.off('ads-pod-started', this.onPodStart);
      this.player.off('ads-pod-ended', this.onPodEnd);
      this.player.off('ads-first-quartile', this.onFirstQuartile);
      this.player.off('ads-midpoint', this.onMidpoint);
      this.player.off('ads-third-quartile', this.onThirdQuartile);
      this.player.off('ads-pause', this.onAdspause);
      this.player.off('ads-play', this.onAdsplay);
    }
  }, {
    key: 'onAdrequest',
    value: function onAdrequest(e) {
      this.sendRequest();
      this.sendDownload({ state: 'ads-request' });
    }
  }, {
    key: 'onAdload',
    value: function onAdload(e) {
      this.sendDownload({ state: 'ads-load' });
    }
  }, {
    key: 'onAdstart',
    value: function onAdstart(e) {
      this.sendRequest();
      this.sendStart();
    }
  }, {
    key: 'onAdend',
    value: function onAdend(e) {
      this.sendEnd();
    }
  }, {
    key: 'onAdskip',
    value: function onAdskip(e) {
      this.sendEnd({ skipped: true });
    }
  }, {
    key: 'onAdserror',
    value: function onAdserror(e) {
      this.sendError();
    }
  }, {
    key: 'onAdsClick',
    value: function onAdsClick(e) {
      this.sendAdClick({ url: 'unknown' });
    }
  }, {
    key: 'onPodStart',
    value: function onPodStart(e) {
      this.sendAdBreakStart();
    }
  }, {
    key: 'onPodEnd',
    value: function onPodEnd(e) {
      this.sendAdBreakEnd();
    }
  }, {
    key: 'onFirstQuartile',
    value: function onFirstQuartile() {
      this.sendAdQuartile({ quartile: 1 });
    }
  }, {
    key: 'onMidpoint',
    value: function onMidpoint() {
      this.sendAdQuartile({ quartile: 2 });
    }
  }, {
    key: 'onThirdQuartile',
    value: function onThirdQuartile() {
      this.sendAdQuartile({ quartile: 3 });
    }
  }, {
    key: 'onAdspause',
    value: function onAdspause() {
      this.sendPause();
    }
  }, {
    key: 'onAdsplay',
    value: function onAdsplay() {
      this.sendResume();
    }
  }]);

  return VideojsAdsTracker;
}(nrvideo.VideoTracker);

exports.default = VideojsAdsTracker;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Static Log class
 *
 * @class
 * @static
 */
var Log = function () {
  function Log() {
    _classCallCheck(this, Log);
  }

  _createClass(Log, null, [{
    key: 'error',

    /**
    * Sends an error console log.
    * @param {...any} [msg] Message to show
    * @static
    */
    value: function error() {
      for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
        msg[_key] = arguments[_key];
      }

      _report(msg, Log.Levels.ERROR, 'darkred');
    }

    /**
     * Sends a warning console log.
     * @method Log.warn
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'warn',
    value: function warn() {
      for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      _report(msg, Log.Levels.WARNING, 'darkorange');
    }

    /**
     * Sends a notice console log.
     * @method Log.notice
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'notice',
    value: function notice() {
      for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      _report([].slice.call(arguments), Log.Levels.NOTICE, 'darkcyan');
    }

    /**
     * Sends a debug message to console.
     * @method Log.debug
     * @static
     * @param {...any} msg Message to show
     */

  }, {
    key: 'debug',
    value: function debug() {
      for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      _report(msg, Log.Levels.DEBUG, 'indigo');
    }

    /**
     * This utility method will add most of the HTML5 common event listeners to the player sent.
     * Events will be reported as DEBUG level messages.
     *
     * @example
     * // Already included events:
     * ['canplay', 'buffering', 'waiting', 'ended', 'play', 'playing', 'pause', 'resume', 'error',
     * 'abort', 'seek', 'seeking', 'seeked', 'stalled', 'dispose', 'loadeddata', 'loadstart',
     * 'loadedmetadata']
     *
     * @method Log.debugCommonVideoEvents
     * @static
     * @param {object|function} o Object to attach the events.
     * @param {array} [extraEvents]
     * An array of extra events to watch. ie:  ['timeupdate', 'progress'].
     * If the first item is null, no common events will be added.
     * @param {function} [report] Callback function called to report events.
     * Default calls Log.debug()
     */

  }, {
    key: 'debugCommonVideoEvents',
    value: function debugCommonVideoEvents(o, extraEvents, report) {
      try {
        if (Log.level <= Log.Levels.DEBUG) {
          report = report || function (e) {
            Log.debug('Event: ' + e.type);
          };

          var playerEvents = ['canplay', 'buffering', 'waiting', 'ended', 'play', 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled', 'dispose', 'loadeddata', 'loadstart', 'loadedmetadata'];
          if (extraEvents) {
            if (extraEvents[0] === null) {
              extraEvents.shift();
              playerEvents = extraEvents;
            } else {
              playerEvents = playerEvents.concat(extraEvents);
            }
          }

          for (var i = 0; i < playerEvents.length; i++) {
            if (typeof o === 'function') {
              o.call(window, playerEvents[i], report);
            } else if (o.on) {
              o.on(playerEvents[i], report);
            } else if (o.addEventListener) {
              o.addEventListener(playerEvents[i], report);
            } else if (o.addEventHandler) {
              o.addEventHandler(playerEvents[i], report);
            } else {
              Log.warn('debugCommonVideoEvents: No common listener function found for ', o);
            }
          }
        }
      } catch (err) {
        Log.warn(err);
      }
    }
  }]);

  return Log;
}();

/**
 * Enum for log levels
 * @enum
 * @static
 * @var
 */


Log.Levels = {
  /** No console outputs */
  SILENT: 5,
  /** Console will show errors */
  ERROR: 4,
  /** Console will show warnings */
  WARNING: 3,
  /** Console will show notices (ie: life-cyrcle logs) */
  NOTICE: 2,
  /** Console will show debug messages. */
  DEBUG: 1,
  /** Show all messages. */
  ALL: 0

  /**
   * Only logs of this imporance or higher will be shown.
   * @example Log.level = Log.Levels.ALL
   * @default Log.Levels.ERROR
   * @static
   */
};Log.level = Log.Levels.ERROR;

/**
 * If true, logs will be outputed with colors.
 * @default true
 * @static
 */
Log.colorful = true;

/**
 * If true, logs will include the time mark.
 * @default true
 * @static
 */
Log.includeTime = true;

/**
 * Prefix included at the start of every log.
 * @default '[New Relic]'
 * @static
 */
Log.prefix = '[nrvideo]';

// PRIVATE MEMBERS

/**
 * Returns a console message
 *
 * @private
 * @param {array} msg Message array, error object or array of messages.
 * @param {Log.Level} [level=Log.Levels.NOTICE] Defines the level of the error sent.
 * Only errors with higher or equal level than Log.logLevel will be displayed.
 * @param {string} [color='darkgreen'] Color of the header
 * @see {@link Log.level}
 */
function _report(msg, level, color) {
  level = level || Log.Levels.NOTICE;
  color = color || 'darkcyan';

  var prefix = Log.prefix;
  if (Log.includeTime) prefix += _getCurrentTime() + ' ';
  prefix += _level2letter(level) + ':';

  // Show messages in actual console if level is enought
  if (Log.level <= level && level !== Log.Levels.SILENT) {
    if (!Log.colorful || typeof document !== 'undefined' && document.documentMode) {
      // document.documentMode exits only in IE
      _plainReport(msg, prefix);
    } else {
      // choose log method
      var logMethod;
      if (level === Log.Levels.ERROR && console.error) {
        logMethod = console.error;
      } else if (level === Log.Levels.WARNING && console.warn) {
        logMethod = console.warn;
      } else if (level === Log.Levels.DEBUG && console.debug) {
        logMethod = console.debug;
      } else {
        logMethod = console.log;
      }

      // print message
      prefix = '%c' + prefix;
      msg.splice(0, 0, prefix, 'color: ' + color);
      logMethod.apply(console, msg);
    }
  }
}

/**
 * Returns the current time in format hh:mm:ss.mmm (with trailing 0s)
 * @private
 * @return {string} Current time.
 */
function _getCurrentTime() {
  var d = new Date();
  var hh = ('0' + d.getDate()).slice(-2);
  var mm = ('0' + d.getMinutes()).slice(-2);
  var ss = ('0' + d.getSeconds()).slice(-2);
  var mmm = ('00' + d.getMilliseconds()).slice(-3);
  return '[' + hh + ':' + mm + ':' + ss + '.' + mmm + ']';
}

/**
 * Returns a console message without style
 *
 * @private
 * @param {(string|object|array)} msg Message string, object or array of messages.
 * @param {string} prefix Prefix of the message.
 */
function _plainReport(msg, prefix) {
  if (msg instanceof Array) {
    for (var m in msg) {
      _plainReport(msg[m], prefix);
    }
  } else {
    if (typeof msg === 'string') {
      console.log(prefix + ' ' + msg);
    } else {
      console.log(prefix + '↵');
      console.log(msg);
    }
  }
}

var _letters = {
  4: 'e', // Error
  3: 'w', // Warning
  2: 'n', // Notice
  1: 'd' // Debug


  /**
   * Transforms a level to a letter to identify every message.
   *
   * @private
   * @param {sLog.Level} level Level of the message
   */
};function _level2letter(level) {
  return _letters[level];
}

/**
 * This function is automatically executed at load.
 * Will search inside window.location.search for attribute 'nrvideo-debug=X'.
 * X can have one of these values, that will modify Log.Levels.
 * 5: SILENT,
 * 4: ERROR,
 * 3: WARNING,
 * 2: NOTICE,
 * 1: DEBUG,
 *
 * If nrvideo-colors=false is present, Log.colorful will be set to false.
 *
 * @private
 */
function _loadLevelFromUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    var m = /\?.*&*nrvideo-debug=(.+)/i.exec(window.location.search);
    if (m !== null) {
      if (m[1] === 'true') {
        Log.level = Log.Levels.ALL;
      } else {
        Log.level = m[1];
      }
    }

    var m2 = /\?.*&*nrvideo-colors=false/i.exec(window.location.search);
    if (m2 !== null) {
      Log.colorful = false;
    }
  }
}

// Execute load level
_loadLevelFromUrl();

exports.default = Log;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class calculates time lapses between two points on time.
 */
var Chrono = function () {
  /**
   * Constructor
   */
  function Chrono() {
    _classCallCheck(this, Chrono);

    this.reset();
  }

  /** Reset chrono values. */


  _createClass(Chrono, [{
    key: "reset",
    value: function reset() {
      /** Start time */
      this.startTime = 0;

      /** Stop time */
      this.stopTime = 0;

      /**
       * If you set an offset in a chrono, its value will be added getDeltaTime and stop.
       *
       * @example
       * let chrono = new Chrono()
       * chrono.offset = 500
       * chrono.start()
       * process.sleep(500)
       * chrono.stop() // Will return 1000
       *
       * @type {number}
       */
      this.offset = 0;
    }

    /**
     * Returns the time between start() and the last stop() in ms. Returns null if start wasn't
     * called.
     * @return {(number|null)} Time lapse in ms.
     */

  }, {
    key: "getDeltaTime",
    value: function getDeltaTime() {
      if (this.startTime) {
        return this.offset + (new Date().getTime() - this.startTime);
      } else {
        return null;
      }
    }

    /**
     * Starts the chrono.
     */

  }, {
    key: "start",
    value: function start() {
      this.startTime = new Date().getTime();
      this.stopTime = 0;
    }

    /**
     * Stops the timer and returns delta time.
     * @return {(number|null)} Returns the delta time
     */

  }, {
    key: "stop",
    value: function stop() {
      this.stopTime = new Date().getTime();
      return this.getDeltaTime();
    }

    /**
     * Creates a copy of the chrono.
     * @returns {Chrono} Cloned chrono
     */

  }, {
    key: "clone",
    value: function clone() {
      var chrono = new Chrono();
      chrono.startTime = this.startTime;
      chrono.stopTime = this.stopTime;
      chrono.offset = this.offset;
      return chrono;
    }
  }]);

  return Chrono;
}();

exports.default = Chrono;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This base class implements a basic behavior of listeners and events. Extend this object to have
 * this feature built-in inside your classes.
 *
 * @class Emitter
 */
var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: 'on',

    /**
     * Sets a listener to a given event. Use {@link emit} to trigger those events.
     * Pass '*' to listen ALL events.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event. Receives event and data.
     * @return this
     */
    value: function on(event, callback) {
      this._listeners = this._listeners || {};
      if (typeof callback === 'function') {
        this._listeners[event] = this._listeners[event] || [];
        this._listeners[event].push(callback);
        return this;
      }
    }

    /**
     * Removes given callback from the listeners of this object.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     * @return this
     */

  }, {
    key: 'off',
    value: function off(event, callback) {
      this._listeners = this._listeners || {};

      if (this._listeners[event]) {
        var index = this._listeners[event].indexOf(callback);
        if (index !== -1) {
          this._listeners[event].splice(index, 1);
        }
      }
      return this;
    }

    /**
     * Emits given event, triggering all the associated callbacks.
     *
     * @param {string} event Name of the event.
     * @param {object} [data] Custom data to be sent to the callbacks.
     * @return this
     */

  }, {
    key: 'emit',
    value: function emit(event, data) {
      var _this = this;

      this._listeners = this._listeners || {};
      data = data || {};

      if (Array.isArray(this._listeners[event])) {
        this._listeners[event].forEach(function (callback) {
          callback.call(_this, { type: event, data: data, target: _this });
        });
      }

      if (Array.isArray(this._listeners['*'])) {
        this._listeners['*'].forEach(function (callback) {
          callback.call(_this, { type: event, data: data, target: _this });
        });
      }

      return this;
    }
  }]);

  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _package = __webpack_require__(6);

var pkg = _interopRequireWildcard(_package);

var _emitter = __webpack_require__(4);

var _emitter2 = _interopRequireDefault(_emitter);

var _chrono = __webpack_require__(3);

var _chrono2 = _interopRequireDefault(_chrono);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Tracker class provides the basic logic to extend Newrelic's Browser Agent capabilities.
 * Trackers are designed to listen third party elements (like video tags, banners, etc.) and send
 * information over to Browser Agent. Extend this class to create your own tracker, override
 * registerListeners and unregisterListeners for full coverage!
 *
 * @example
 * Tracker instances should be added to Core library to start sending data:
 * nrvideo.Core.addTracker(new Tracker())
 *
 * @extends Emitter
 */
var Tracker = function (_Emitter) {
  _inherits(Tracker, _Emitter);

  /**
   * Constructor, receives options. You should call {@see registerListeners} after this.
   *
   * @param {Object} [options] Options for the tracker. See {@link setOptions}.
   */
  function Tracker(options) {
    _classCallCheck(this, Tracker);

    /**
     * If you add something to this custom dictionary it will be added to every action. If you set
     * any value, it will always override the values returned by the getters.
     *
     * @example
     * If you define tracker.customData.contentTitle = 'a' and tracker.getTitle() returns 'b'.
     * 'a' will prevail.
     */
    var _this = _possibleConstructorReturn(this, (Tracker.__proto__ || Object.getPrototypeOf(Tracker)).call(this));

    _this.customData = {};

    /**
     * Set time between hearbeats, in ms.
     */
    _this.heartbeat = null;

    /**
     * Another Tracker instance. Useful to relate ad Trackers to their parent content Trackers.
     * @type Tracker
     */
    _this.parentTracker = null;

    /**
     * Chrono that counts time since this class was instantiated.
     * @private
     */
    _this._trackerReadyChrono = new _chrono2.default();
    _this._trackerReadyChrono.start();

    options = options || {};
    _this.setOptions(options);
    return _this;
  }

  /**
   * Set options for the Tracker.
   *
   * @param {Object} [options] Options for the tracker.
   * @param {number} [options.heartbeat] Set time between heartbeats. See {@link heartbeat}.
   * @param {Object} [options.customData] Set custom data. See {@link customData}.
   * @param {Tracker} [options.parentTracker] Set parent tracker. See {@link parentTracker}.
   */


  _createClass(Tracker, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options) {
        if (options.parentTracker) this.parentTracker = options.parentTracker;
        if (options.customData) this.customData = options.customData;
        if (options.heartbeat) this.heartbeat = options.heartbeat;
      }
    }

    /**
     * Prepares tracker to dispose. Calls {@see unregisterListeners} and drops references.
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.unregisterListeners();
    }

    /**
     * Override this method to register listeners to third party elements.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.emit(Tracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'registerListeners',
    value: function registerListeners() {}

    /**
     * Override this method to unregister listeners to third party elements created with
     * {@see registerListeners}.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  unregisterListeners() {
     *    this.player.off('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.emit(Tracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {}

    /**
     * Returns heartbeat time interval. 30000 (30s) if not set. See {@link setOptions}.
     * @return {number} Heartbeat interval in ms.
     * @final
     */

  }, {
    key: 'getHeartbeat',
    value: function getHeartbeat() {
      if (this.heartbeat) {
        return this.heartbeat;
      } else if (this.parentTracker && this.parentTracker.heartbeat) {
        return this.parentTracker.heartbeat;
      } else {
        return 30000;
      }
    }

    /**
     * Starts heartbeating. Interval period set by options.heartbeat. Min 5000 ms.
     * This method is automaticaly called by the tracker once sendRequest is called.
     */

  }, {
    key: 'startHeartbeat',
    value: function startHeartbeat() {
      this._heartbeatInterval = setInterval(this.sendHeartbeat.bind(this), Math.max(this.getHeartbeat(), 5000));
    }

    /**
     * Stops heartbeating. This method is automaticaly called by the tracker.
     */

  }, {
    key: 'stopHeartbeat',
    value: function stopHeartbeat() {
      if (this._heartbeatInterval) {
        clearInterval(this._heartbeatInterval);
      }
    }

    /**
     * Heartbeating allows you to call this function each X milliseconds, defined by
     * {@link getHeartbeat}. This is useful to send regular events to track changes.
     *
     * By default it will send {@link Tracker.Events.HEARTBEAT}.
     * To start heartbeating use {@link startHeartbeat} and to stop them use {@link stopHeartbeat}.
     *
     * @example
     * Override this method to define your own Heartbeat reporting.
     *
     * class TrackerChild extends Tracker {
     *  sendHeartbeat (att) {
     *    this.send('MY_HEARBEAT_EVENT')
     *  }
     * }
     *
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendHeartbeat',
    value: function sendHeartbeat(att) {
      this.send(Tracker.Events.HEARTBEAT, att);
    }

    /**
     * Override this method to return attributes for actions.
     *
     * @example
     * class SpecificTracker extends Tracker {
     *  getAttributes(att) {
     *    att = att || {}
     *    att.information = 'something'
     *    return att
     *  }
     * }
     *
     * @param {object} [att] Collection of key value attributes
     * @return {object} Filled attributes
     * @final
     */

  }, {
    key: 'getAttributes',
    value: function getAttributes(att) {
      att = att || {};
      att.trackerName = this.getTrackerName();
      att.trackerVersion = this.getTrackerVersion();
      att.coreVersion = pkg.version;
      att.timeSinceTrackerReady = this._trackerReadyChrono.getDeltaTime();

      for (var key in this.customData) {
        att[key] = this.customData[key];
      }

      return att;
    }

    /** Override to change of the Version of tracker. ie: '1.0.1' */

  }, {
    key: 'getTrackerVersion',
    value: function getTrackerVersion() {
      return pkg.version;
    }

    /** Override to change of the Name of the tracker. ie: 'custom-html5' */

  }, {
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'base-tracker';
    }

    /**
     * Send given event. Will automatically call {@see getAttributes} to fill information.
     * Internally, this will call {@see Emitter#emit}, so you could listen any event fired.
     *
     * @example
     * tracker.send('BANNER_CLICK', { url: 'http....' })
     *
     * @param {string} event Event name
     * @param {object} [att] Key:value dictionary filled with attributes.
     */

  }, {
    key: 'send',
    value: function send(event, att) {
      this.emit(event, this.getAttributes(att));
    }
  }]);

  return Tracker;
}(_emitter2.default);

/**
 * Enumeration of events fired by this class.
 *
 * @static
 * @memberof Tracker
 * @enum
 */


Tracker.Events = {
  HEARTBEAT: 'HEARTBEAT'
};

exports.default = Tracker;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {"_from":"github:newrelic/video-core-js#v0.13.0","_id":"newrelic-video-core@0.13.0","_inBundle":false,"_integrity":"","_location":"/newrelic-video-core","_phantomChildren":{},"_requested":{"type":"git","raw":"github:newrelic/video-core-js#v0.13.0","rawSpec":"github:newrelic/video-core-js#v0.13.0","saveSpec":"github:newrelic/video-core-js#v0.13.0","fetchSpec":null,"gitCommittish":"v0.13.0"},"_requiredBy":["#USER","/"],"_resolved":"github:newrelic/video-core-js#c7880aae36f1d7feb5b846910ec27e37bd47bc22","_spec":"github:newrelic/video-core-js#v0.13.0","_where":"/Users/asantaren/Documents/Dev/javascript/video-videojs-js","author":{"name":"Jordi Aguilar"},"bugs":{"url":"https://github.com/newrelic/video-core-js/issues"},"bundleDependencies":false,"dependencies":{},"deprecated":false,"description":"New Relic video tracking core library","devDependencies":{"aws-sdk":"^2.150.0","babel-core":"^6.25.0","babel-loader":"^7.1.1","babel-preset-env":"^1.6.0","chai":"^4.1.0","ink-docstrap":"^1.3.0","jsdoc":"^3.5.4","jsdoc-babel":"^0.3.0","mocha":"^3.5.0","nyc":"^11.1.0","sinon":"^2.4.1","webpack":"^3.4.1"},"homepage":"https://github.com/newrelic/video-core-js#readme","license":"MIT","main":"src/index.js","name":"newrelic-video-core","repository":{"type":"git","url":"git+https://github.com/newrelic/video-core-js.git"},"scripts":{"build":"webpack -p","build:dev":"webpack","clean":"rm -rf dist coverage doc","deploy":"node scripts/deploy.js","doc":"jsdoc -c jsdoc.json -d doc","test":"nyc --reporter=html --reporter=text mocha --compilers js:babel-core/register","watch":"webpack -p --progress --color --watch","watch:dev":"webpack --progress --color --watch"},"version":"0.13.0"}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chrono = __webpack_require__(3);

var _chrono2 = _interopRequireDefault(_chrono);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * State machine for a VideoTracker and its monitored video.
 */
var VideoTrackerState = function () {
  /** Constructor */
  function VideoTrackerState() {
    _classCallCheck(this, VideoTrackerState);

    this.reset();

    /**
     * Time when the VideoTrackerState was initializated.
     * @private
     */
    this._createdAt = Date.now();
  }

  /** Resets all flags and chronos. */


  _createClass(VideoTrackerState, [{
    key: 'reset',
    value: function reset() {
      /**
       * Unique identifier of the view.
       * @private
       */
      this._viewSession = null;

      /**
       * Number of views seen.
       * @private
       */
      this._viewCount = 0;

      /**
       * True if it is tracking ads.
       * @private
       */
      this._isAd = false;

      /**
       * Number of errors fired. 'End' resets it.
       */
      this.numberOfErrors = 0;

      /**
       * Number of ads shown.
       */
      this.numberOfAds = 0;

      /**
       * Number of videos played.
       */
      this.numberOfVideos = 0;

      /**
       * The amount of ms the user has been watching content (not paused, not buffering, not ads...)
       */
      this.totalPlaytime = 0;

      /** True if you are in the middle of an ad break. */
      this.isAdBreak = false;

      /** True if initial buffering event already happened. */
      this.initialBufferingHappened = false;

      this.resetFlags();
      this.resetChronos();
    }

    /** Resets flags. */

  }, {
    key: 'resetFlags',
    value: function resetFlags() {
      /** True once the player has finished loading. */
      this.isPlayerReady = false;

      /** True if the video has been user-requested to play. ie: user cicks play. */
      this.isRequested = false;

      /** True if the video has starting playing. ie: actual images/audio showing in screen. */
      this.isStarted = false;

      /** True if the video is paused. */
      this.isPaused = false;

      /** True if the video is performing a seek action. */
      this.isSeeking = false;

      /** True if the video is currently buffering. */
      this.isBuffering = false;

      /** True if the video is currently playing (not buffering, not paused...) */
      this.isPlaying = false;
    }

    /** Resets chronos. */

  }, {
    key: 'resetChronos',
    value: function resetChronos() {
      /** Chrono that counts time since last requested event. */
      this.timeSinceRequested = new _chrono2.default();

      /** Chrono that counts time since last start event. */
      this.timeSinceStarted = new _chrono2.default();

      /** Chrono that counts time since last pause event. */
      this.timeSincePaused = new _chrono2.default();

      /** Chrono that counts time since last seeking start event. */
      this.timeSinceSeekBegin = new _chrono2.default();

      /** Chrono that counts time since last buffering start event. */
      this.timeSinceBufferBegin = new _chrono2.default();

      /** Chrono that counts time since last ad break start event. */
      this.timeSinceAdBreakStart = new _chrono2.default();

      /** Chrono that counts time since last download event. */
      this.timeSinceLastDownload = new _chrono2.default();

      /** Chrono that counts time since last heartbeat. */
      this.timeSinceLastHeartbeat = new _chrono2.default();

      /** Chrono that counts time since last rendition change. */
      this.timeSinceLastRenditionChange = new _chrono2.default();

      /** Ads only. Chrono that counts time since last ad quartile. */
      this.timeSinceLastAdQuartile = new _chrono2.default();

      /** Content only. Chrono that counts time since last AD_END. */
      this.timeSinceLastAd = new _chrono2.default();

      /** Chrono that counts the ammount of time the video have been playing since the last event. */
      this.playtimeSinceLastEvent = new _chrono2.default();
    }

    /** Returns true if the tracker is currently on ads. */

  }, {
    key: 'isAd',
    value: function isAd() {
      return this._isAd;
    }

    /** Sets if the tracker is currenlty tracking ads */

  }, {
    key: 'setIsAd',
    value: function setIsAd(isAd) {
      this._isAd = isAd;
    }

    /**
     * Returns a random-generated view Session ID, useful to sort by views.
     */

  }, {
    key: 'getViewSession',
    value: function getViewSession() {
      if (!this._viewSession) {
        var time = new Date().getTime();
        var random = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);

        this._viewSession = time + '-' + random;
      }

      return this._viewSession;
    }

    /**
     * Returns a random-generated view Session ID, plus a view count, allowing you to distinguish
     * between two videos played in the same session.
     */

  }, {
    key: 'getViewId',
    value: function getViewId() {
      return this.getViewSession() + '-' + this._viewCount;
    }

    /**
     * Fills given object with state-based attributes.
     *
     * @param {object} att Collection fo key value attributes
     * @return {object} Filled attributes
     */

  }, {
    key: 'getStateAttributes',
    value: function getStateAttributes(att) {
      att = att || {};

      if (this.isAd()) {
        // Ads only
        if (this.isRequested) {
          att.timeSinceAdRequested = this.timeSinceRequested.getDeltaTime();
          att.timeSinceLastAdHeartbeat = this.timeSinceLastHeartbeat.getDeltaTime();
        }
        if (this.isStarted) att.timeSinceAdStarted = this.timeSinceStarted.getDeltaTime();
        if (this.isPaused) att.timeSinceAdPaused = this.timeSincePaused.getDeltaTime();
        if (this.isBuffering) att.timeSinceAdBufferBegin = this.timeSinceBufferBegin.getDeltaTime();
        if (this.isSeeking) att.timeSinceAdSeekBegin = this.timeSinceSeekBegin.getDeltaTime();
        if (this.isAdBreak) att.timeSinceAdBreakBegin = this.timeSinceAdBreakStart.getDeltaTime();
        att.numberOfAds = this.numberOfAds;
      } else {
        // Content only
        if (this.isRequested) {
          att.timeSinceRequested = this.timeSinceRequested.getDeltaTime();
          att.timeSinceLastHeartbeat = this.timeSinceLastHeartbeat.getDeltaTime();
        }
        if (this.isStarted) att.timeSinceStarted = this.timeSinceStarted.getDeltaTime();
        if (this.isPaused) att.timeSincePaused = this.timeSincePaused.getDeltaTime();
        if (this.isBuffering) att.timeSinceBufferBegin = this.timeSinceBufferBegin.getDeltaTime();
        if (this.isSeeking) att.timeSinceSeekBegin = this.timeSinceSeekBegin.getDeltaTime();
        att.timeSinceLastAd = this.timeSinceLastAd.getDeltaTime();
        att.numberOfVideos = this.numberOfVideos;
      }
      att.numberOfErrors = this.numberOfErrors;

      // Playtime
      if (!this.isAd()) {
        // Content only
        if (this.playtimeSinceLastEvent.startTime > 0) {
          att.playtimeSinceLastEvent = this.playtimeSinceLastEvent.getDeltaTime();
        } else {
          att.playtimeSinceLastEvent = 0;
        }
        if (this.isPlaying) {
          this.playtimeSinceLastEvent.start();
        } else {
          this.playtimeSinceLastEvent.reset();
        }
        this.totalPlaytime += att.playtimeSinceLastEvent;
        att.totalPlaytime = this.totalPlaytime;
      }

      return att;
    }

    /**
     * Augments view count. This will be called with each *_START and *_END.
     */

  }, {
    key: 'goViewCountUp',
    value: function goViewCountUp() {
      this._viewCount++;
    }

    /**
     * Checks flags and changes state.
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goPlayerReady',
    value: function goPlayerReady() {
      if (!this.isPlayerReady) {
        this.isPlayerReady = true;
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goRequest',
    value: function goRequest() {
      if (!this.isRequested) {
        this.isRequested = true;
        this.timeSinceLastAd.reset();
        this.timeSinceRequested.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goStart',
    value: function goStart() {
      if (this.isRequested && !this.isStarted) {
        if (this.isAd()) {
          this.numberOfAds++;
        } else {
          this.numberOfVideos++;
        }
        this.isStarted = true;
        this.isPlaying = true;
        this.timeSinceStarted.start();
        this.playtimeSinceLastEvent.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goEnd',
    value: function goEnd() {
      if (this.isRequested) {
        this.numberOfErrors = 0;
        this.resetFlags();
        this.timeSinceRequested.stop();
        this.timeSinceStarted.stop();
        this.playtimeSinceLastEvent.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goPause',
    value: function goPause() {
      if (this.isStarted && !this.isPaused) {
        this.isPaused = true;
        this.isPlaying = false;
        this.timeSincePaused.start();
        this.playtimeSinceLastEvent.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goResume',
    value: function goResume() {
      if (this.isStarted && this.isPaused) {
        this.isPaused = false;
        this.isPlaying = true;
        this.timeSincePaused.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goBufferStart',
    value: function goBufferStart() {
      if (this.isStarted && !this.isBuffering) {
        this.isBuffering = true;
        this.isPlaying = false;
        this.timeSinceBufferBegin.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goBufferEnd',
    value: function goBufferEnd() {
      if (this.isStarted && this.isBuffering) {
        this.isBuffering = false;
        this.isPlaying = true;
        this.timeSinceBufferBegin.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goSeekStart',
    value: function goSeekStart() {
      if (this.isStarted && !this.isSeeking) {
        this.isSeeking = true;
        this.isPlaying = false;
        this.timeSinceSeekBegin.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goSeekEnd',
    value: function goSeekEnd() {
      if (this.isStarted && this.isSeeking) {
        this.isSeeking = false;
        this.isPlaying = true;
        this.timeSinceSeekBegin.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goAdBreakStart',
    value: function goAdBreakStart() {
      if (!this.isAdBreak) {
        this.isAdBreak = true;
        this.timeSinceAdBreakStart.start();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Checks flags and changes state
     * @returns {boolean} True if the state changed.
     */

  }, {
    key: 'goAdBreakEnd',
    value: function goAdBreakEnd() {
      if (this.isAdBreak) {
        this.isRequested = false;
        this.isAdBreak = false;
        this.timeSinceAdBreakStart.stop();
        return true;
      } else {
        return false;
      }
    }

    /**
     * Restarts download chrono.
     */

  }, {
    key: 'goDownload',
    value: function goDownload() {
      this.timeSinceLastDownload.start();
    }

    /**
     * Restarts heartbeat chrono.
     */

  }, {
    key: 'goHeartbeat',
    value: function goHeartbeat() {
      this.timeSinceLastHeartbeat.start();
    }

    /**
     * Restarts rendition change chrono.
     */

  }, {
    key: 'goRenditionChange',
    value: function goRenditionChange() {
      this.timeSinceLastRenditionChange.start();
    }

    /**
     * Restarts ad quartile chrono.
     */

  }, {
    key: 'goAdQuartile',
    value: function goAdQuartile() {
      this.timeSinceLastAdQuartile.start();
    }

    /**
     * Increments error counter.
     */

  }, {
    key: 'goError',
    value: function goError() {
      this.numberOfErrors++;
    }

    /**
     * Restarts last ad chrono.
     */

  }, {
    key: 'goLastAd',
    value: function goLastAd() {
      this.timeSinceLastAd.start();
    }
  }]);

  return VideoTrackerState;
}();

exports.default = VideoTrackerState;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {"name":"newrelic-video-videojs","version":"0.3.1","description":"New relic tracker for Videojs","main":"src/index.js","scripts":{"build":"webpack -p","build:dev":"webpack","watch":"webpack -p --progress --color --watch","watch:dev":"webpack --progress --color --watch","prezip":"npm run build","zip":"zip -P newrelic -x '*.DS_Store' -x 'samples/agent.js' -r videojs.zip dist samples README.md CHANGELOG.md EULA.md","clean":"rm -rf dist *.zip","deploy":"node scripts/deploy.js"},"repository":{"type":"git","url":"https://github.com/newrelic/video-videojs-js.git"},"author":"Jordi Aguilar","contributors":["Andreu Santarén Llop"],"license":"MIT","dependencies":{"newrelic-video-core":"github:newrelic/video-core-js#v0.13.0"},"devDependencies":{"aws-sdk":"^2.582.0","babel-core":"^6.26.3","babel-loader":"^7.1.5","babel-preset-env":"^1.7.0","videojs-ima":"^0.6.0","webpack":"^3.12.0"}}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _newrelicVideoCore = __webpack_require__(0);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _tracker = __webpack_require__(13);

var _tracker2 = _interopRequireDefault(_tracker);

__webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

nrvideo.VideojsTracker = _tracker2.default;
module.exports = nrvideo;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _log = __webpack_require__(2);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Static class that sums up core functionalities of the library.
 * @static
 */
var Core = function () {
  function Core() {
    _classCallCheck(this, Core);
  }

  _createClass(Core, null, [{
    key: 'addTracker',

    /**
     * Add a tracker to the system. Trackers added will start reporting its events to NR's backend.
     *
     * @param {(Emitter|Tracker)} tracker
     */
    value: function addTracker(tracker) {
      if (tracker.on && tracker.emit) {
        trackers.push(tracker);
        tracker.on('*', eventHandler);
      } else {
        _log2.default.error('Tried to load a non-tracker.', tracker);
      }
    }

    /**
     * Disposes and remove given tracker. Removes its listeners.
     *
     * @param {Tracker} tracker Tracker to remove.
     */

  }, {
    key: 'removeTracker',
    value: function removeTracker(tracker) {
      tracker.off('*', eventHandler);
      tracker.dispose();
      var index = trackers.indexOf(tracker);
      if (index !== -1) trackers.splice(index, 1);
    }

    /**
     * Returns the array of trackers.
     *
     * @returns {Tracker[]} Array of trackers.
     */

  }, {
    key: 'getTrackers',
    value: function getTrackers() {
      return trackers;
    }

    /**
     * Sends given event. Uses newrelic Browser Agent.
     * @param {String} event Event to send.
     * @param {Object} data Data associated to the event.
     */

  }, {
    key: 'send',
    value: function send(event, data) {
      if (typeof newrelic !== 'undefined' && newrelic.addPageAction) {
        newrelic.addPageAction(event, data);
      } else {
        if (!isErrorShown) {
          _log2.default.error('newrelic.addPageAction() is not available.', 'In order to use NewRelic Video you will need New Relic Browser Agent.');
          isErrorShown = true;
        }
      }
    }

    /**
     * Sends an error event. This may be used for external errors launched by the app, the network or
     * any external factor. Note that errors within the player are normally reported with
     * tracker.sendError, so this method should not be used to report those.
     *
     * @param {object} att attributes to be sent along the error.
     */

  }, {
    key: 'sendError',
    value: function sendError(att) {
      Core.send('ERROR', att);
    }
  }]);

  return Core;
}();

var trackers = [];
var isErrorShown = false;

/**
 * Logs and sends given event.
 *
 * @private
 * @param {Event} e Event
 */
function eventHandler(e) {
  var data = cleanData(e.data);
  if (_log2.default.level <= _log2.default.Levels.DEBUG) {
    _log2.default.notice('Sent', e.type, data);
  } else {
    _log2.default.notice('Sent', e.type);
  }
  Core.send(e.type, data);
}

/**
 * Cleans given object, removing all items with value === null.
 * @private
 * @param {Object} data Data to clean
 * @returns {Object} Cleaned object
 */
function cleanData(data) {
  var ret = {};
  for (var i in data) {
    if (data[i] !== null && typeof data[i] !== 'undefined') ret[i] = data[i];
  }
  return ret;
}

exports.default = Core;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Constants for the library.
 * @class Constants
 * @static
 */
var Constants = function Constants() {
  _classCallCheck(this, Constants);
};

/**
 * Enum for types/positions of ads.
 * @example var type = Constants.AdPositions.PRE
 * @enum {String}
 */


Constants.AdPositions = {
  /** For ads shown before the content. */
  PRE: 'pre',
  /** For ads shown during the content. */
  MID: 'mid',
  /** For ads shown after the content. */
  POST: 'post'
};

exports.default = Constants;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _log = __webpack_require__(2);

var _log2 = _interopRequireDefault(_log);

var _tracker = __webpack_require__(5);

var _tracker2 = _interopRequireDefault(_tracker);

var _videotrackerstate = __webpack_require__(7);

var _videotrackerstate2 = _interopRequireDefault(_videotrackerstate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base video tracker class provides extensible tracking over video elements. See {@link Tracker}.
 * Extend this class to create your own video tracker class. Override getter methods and
 * registerListeners/unregisterListeners to provide full integration with your video experience.
 *
 * @example
 * Tracker instances should be added to Core library to start sending data:
 * nrvideo.Core.addTracker(new Tracker())
 *
 * @extends Tracker
 */
var VideoTracker = function (_Tracker) {
  _inherits(VideoTracker, _Tracker);

  /**
   * Constructor, receives player and options.
   * Lifecycle: constructor > {@link setOptions} > {@link setPlayer} > {@link registerListeners}.
   *
   * @param {Object} [player] Player to track. See {@link setPlayer}.
   * @param {Object} [options] Options for the tracker. See {@link setOptions}.
   */
  function VideoTracker(player, options) {
    _classCallCheck(this, VideoTracker);

    /**
     * TrackerState instance. Stores the state of the view. Tracker will automatically update the
     * state of its instance, so there's no need to modify/interact with it manually.
     * @type TrackerState
     */
    var _this = _possibleConstructorReturn(this, (VideoTracker.__proto__ || Object.getPrototypeOf(VideoTracker)).call(this));

    _this.state = new _videotrackerstate2.default();

    /**
     * Another Tracker instance to track ads.
     * @type Tracker
     */
    _this.adsTracker = null;

    options = options || {};
    _this.setOptions(options);
    if (player) _this.setPlayer(player, options.tag);

    _log2.default.notice('Tracker ' + _this.getTrackerName() + ' v' + _this.getTrackerVersion() + ' is ready.');
    return _this;
  }

  /**
   * Set options for the Tracker.
   *
   * @param {Object} [options] Options for the tracker.
   * @param {Boolean} [options.isAd] True if the tracker is tracking ads. See {@link setIsAd}.
   * @param {number} [options.heartbeat] Set time between heartbeats. See {@link heartbeat}.
   * @param {Object} [options.customData] Set custom data. See {@link customData}.
   * @param {Tracker} [options.parentTracker] Set parent tracker. See {@link parentTracker}.
   * @param {Tracker} [options.adsTracker] Set ads tracker. See {@link adsTracker}.
   * @param {Object} [options.tag] DOM element to track. See {@link setPlayer}.
   */


  _createClass(VideoTracker, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options) {
        if (options.adsTracker) this.setAdsTracker(options.adsTracker);
        if (typeof options.isAd === 'boolean') this.setIsAd(options.isAd);
        _tracker2.default.prototype.setOptions.apply(this, arguments);
      }
    }

    /**
     * Set a player and/or a tag. If there was one already defined, it will call dispose() first.
     * Will call this.registerListeners() afterwards.
     *
     * @param {Object|string} player New player to save as this.player. If a string is passed,
     * document.getElementById will be called.
     * @param {DOMObject|string} [tag] Optional DOMElement to save as this.tag. If a string is passed,
     * document.getElementById will be called.
     */

  }, {
    key: 'setPlayer',
    value: function setPlayer(player, tag) {
      if (this.player || this.tag) this.dispose();

      if (typeof document !== 'undefined' && document.getElementById) {
        if (typeof player === 'string') player = document.getElementById(player);
        if (typeof tag === 'string') tag = document.getElementById(tag);
      }

      tag = tag || player; // if no tag is passed, use player as both.

      this.player = player;
      this.tag = tag;
      this.registerListeners();
    }

    /** Returns true if the tracker is currently on ads. */

  }, {
    key: 'isAd',
    value: function isAd() {
      return this.state.isAd();
    }

    /** Sets if the tracker is currenlty tracking ads */

  }, {
    key: 'setIsAd',
    value: function setIsAd(isAd) {
      this.state.setIsAd(isAd);
    }

    /**
     * Use this function to set up a child ad tracker. You will be able to access it using
     * this.adsTracker.
     *
     * @param {Tracker} tracker Ad tracker to add
     */

  }, {
    key: 'setAdsTracker',
    value: function setAdsTracker(tracker) {
      this.disposeAdsTracker(); // dispose current one
      if (tracker) {
        this.adsTracker = tracker;
        this.adsTracker.setIsAd(true);
        this.adsTracker.parentTracker = this;
        this.adsTracker.on('*', funnelAdEvents.bind(this));
      }
    }

    /**
     * Dispose current adsTracker.
     */

  }, {
    key: 'disposeAdsTracker',
    value: function disposeAdsTracker() {
      if (this.adsTracker) {
        this.adsTracker.off('*', funnelAdEvents);
        this.adsTracker.dispose();
      }
    }

    /**
     * Prepares tracker to dispose. Calls unregisterListener and drops references to player and tag.
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.stopHeartbeat();
      this.disposeAdsTracker();
      this.unregisterListeners();
      this.player = null;
      this.tag = null;
    }

    /**
     * Override this method to register listeners to player/tag.
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.send(VideoTracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'registerListeners',
    value: function registerListeners() {}

    /**
     * Override this method to unregister listeners to player/tag created in registerListeners
     * @example
     * class SpecificTracker extends Tracker {
     *  registerListeners() {
     *    this.player.on('play', () => this.playHandler)
     *  }
     *
     *  unregisterListeners() {
     *    this.player.off('play', () => this.playHandler)
     *  }
     *
     *  playHandler() {
     *    this.send(VideoTracker.Events.REQUESTED)
     *  }
     * }
     */

  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {}

    /**
     * Trackers will generate unique id's for every new video iteration. If you have your own unique
     * view value, you can override this method to return it.
     * If the tracker has a parentTracker defined, parent viewId will be used.
     */

  }, {
    key: 'getViewId',
    value: function getViewId() {
      if (this.parentTracker) {
        return this.parentTracker.getViewId();
      } else {
        return this.state.getViewId();
      }
    }

    /**
     * Trackers will generate unique id's for every new video session. If you have your own unique
     * view value, you can override this method to return it.
     * If the tracker has a parentTracker defined, parent viewId will be used.
     */

  }, {
    key: 'getViewSession',
    value: function getViewSession() {
      if (this.parentTracker) {
        return this.parentTracker.getViewSession();
      } else {
        return this.state.getViewSession();
      }
    }

    /** Override to return the Id of the video. */

  }, {
    key: 'getVideoId',
    value: function getVideoId() {
      return null;
    }

    /** Override to return Title of the video. */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      return null;
    }

    /** Override to return True if the video is live. */

  }, {
    key: 'isLive',
    value: function isLive() {
      return null;
    }

    /** Override to return Bitrate (in bits) of the video. */

  }, {
    key: 'getBitrate',
    value: function getBitrate() {
      return null;
    }

    /** Calculates consumed bitrate using webkitVideoDecodedByteCount. */

  }, {
    key: 'getWebkitBitrate',
    value: function getWebkitBitrate() {
      if (this.tag && this.tag.webkitVideoDecodedByteCount) {
        var bitrate = void 0;
        if (this._lastWebkitBitrate) {
          bitrate = this.tag.webkitVideoDecodedByteCount;
          var delta = bitrate - this._lastWebkitBitrate;
          var seconds = this.getHeartbeat() / 1000;
          bitrate = Math.round(delta / seconds * 8);
        }
        this._lastWebkitBitrate = this.tag.webkitVideoDecodedByteCount;
        return bitrate || null;
      }
    }

    /** Override to return Name of the rendition (ie: 1080p). */

  }, {
    key: 'getRenditionName',
    value: function getRenditionName() {
      return null;
    }

    /** Override to return Target Bitrate of the rendition. */

  }, {
    key: 'getRenditionBitrate',
    value: function getRenditionBitrate() {
      return null;
    }

    /**
     * This method will return 'up', 'down' or null depending on if the bitrate of the rendition
     * have changed from the last time it was called.
     *
     * @param {boolean} [saveNewRendition=false] If true, current rendition will be stored to be used
     * the next time this method is called. This allows you to call this.getRenditionShift() without
     * saving the current rendition and thus preventing interferences with RENDITION_CHANGE events.
     */

  }, {
    key: 'getRenditionShift',
    value: function getRenditionShift(saveNewRendition) {
      var current = this.getRenditionBitrate();
      var last = void 0;
      if (this.isAd()) {
        last = this._lastAdRendition;
        if (saveNewRendition) this._lastAdRendition = current;
      } else {
        last = this._lastRendition;
        if (saveNewRendition) this._lastRendition = current;
      }

      if (!current || !last) {
        return null;
      } else {
        if (current > last) {
          return 'up';
        } else if (current < last) {
          return 'down';
        } else {
          return null;
        }
      }
    }

    /** Override to return renidtion actual Height (before re-scaling). */

  }, {
    key: 'getRenditionHeight',
    value: function getRenditionHeight() {
      return this.tag ? this.tag.videoHeight : null;
    }

    /** Override to return rendition actual Width (before re-scaling). */

  }, {
    key: 'getRenditionWidth',
    value: function getRenditionWidth() {
      return this.tag ? this.tag.videoWidth : null;
    }

    /** Override to return Duration of the video, in ms. */

  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.tag ? this.tag.duration : null;
    }

    /** Override to return Playhead (currentTime) of the video, in ms. */

  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      return this.tag ? this.tag.currentTime : null;
    }

    /**
     * Override to return Language of the video. We recommend using locale notation, ie: en_US.
     * {@see https://gist.github.com/jacobbubu/1836273}
     */

  }, {
    key: 'getLanguage',
    value: function getLanguage() {
      return null;
    }

    /** Override to return URL of the resource being played. */

  }, {
    key: 'getSrc',
    value: function getSrc() {
      return this.tag ? this.tag.currentSrc : null;
    }

    /** Override to return Playrate (speed) of the video. ie: 1.0, 0.5, 1.25... */

  }, {
    key: 'getPlayrate',
    value: function getPlayrate() {
      return this.tag ? this.tag.playbackRate : null;
    }

    /** Override to return True if the video is currently muted. */

  }, {
    key: 'isMuted',
    value: function isMuted() {
      return this.tag ? this.tag.muted : null;
    }

    /** Override to return True if the video is currently fullscreen. */

  }, {
    key: 'isFullscreen',
    value: function isFullscreen() {
      return null;
    }

    /** Override to return the CDN serving the content. */

  }, {
    key: 'getCdn',
    value: function getCdn() {
      return null;
    }

    /** Override to return the Name of the player. */

  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return this.getTrackerName();
    }

    /** Override to return the Version of the player. */

  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return null;
    }

    /** Override to return current FPS (Frames per second). */

  }, {
    key: 'getFps',
    value: function getFps() {
      return null;
    }

    /**
     * Override to return if the player was autoplayed. By default: this.tag.autoplay
     */

  }, {
    key: 'isAutoplayed',
    value: function isAutoplayed() {
      return this.tag ? this.tag.autoplay : null;
    }

    /**
     * Override to return the player preload attribute. By default: this.tag.preload
     */

  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this.tag ? this.tag.preload : null;
    }

    // Only for ads
    /**
     * Override to return Quartile of the ad. 0 before first, 1 after first quartile, 2 after
     * midpoint, 3 after third quartile, 4 when completed.
     */

  }, {
    key: 'getAdQuartile',
    value: function getAdQuartile() {
      return null;
    }

    /**
     * Override to return the position of the ad. Use {@link Constants.AdPositions} enum
     * to fill this data.
     */

  }, {
    key: 'getAdPosition',
    value: function getAdPosition() {
      return this.state.isStarted ? 'pre' : 'mid';
    }

    /**
     * Override to return the ad partner. ie: ima, freewheel...
     */

  }, {
    key: 'getAdPartner',
    value: function getAdPartner() {
      return null;
    }

    /**
     * Override to return the creative id of the ad.
     */

  }, {
    key: 'getAdCreativeId',
    value: function getAdCreativeId() {
      return null;
    }

    /**
     * Do NOT override. This method fills all the appropiate attributes for tracked video.
     *
     * @param {object} [att] Collection of key value attributes
     * @return {object} Filled attributes
     * @final
     */

  }, {
    key: 'getAttributes',
    value: function getAttributes(att) {
      att = _tracker2.default.prototype.getAttributes.apply(this, arguments);

      if (typeof att.isAd === 'undefined') att.isAd = this.isAd();
      att.viewSession = this.getViewSession();
      att.viewId = this.getViewId();
      att.playerName = this.getPlayerName();
      att.playerVersion = this.getPlayerVersion();

      try {
        att.pageUrl = window.location.href;
      } catch (err) {/* skip */}

      if (this.isAd()) {
        // Ads
        att.adId = this.getVideoId();
        att.adTitle = this.getTitle();
        att.adBitrate = this.getBitrate() || this.getWebkitBitrate();
        att.adRenditionName = this.getRenditionName();
        att.adRenditionBitrate = this.getRenditionBitrate();
        att.adRenditionHeight = this.getRenditionHeight();
        att.adRenditionWidth = this.getRenditionWidth();
        att.adDuration = this.getDuration();
        att.adPlayhead = this.getPlayhead();
        att.adLanguage = this.getLanguage();
        att.adSrc = this.getSrc();
        att.adCdn = this.getCdn();
        att.adIsMuted = this.isMuted();
        att.adFps = this.getFps();
        // ad exclusives
        att.adQuartile = this.getAdQuartile();
        att.adPosition = this.getAdPosition();
        att.adCreativeId = this.getAdCreativeId();
        att.adPartner = this.getAdPartner();
      } else {
        // no ads
        att.contentId = this.getVideoId();
        att.contentTitle = this.getTitle();
        att.contentIsLive = this.isLive();
        att.contentBitrate = this.getBitrate() || this.getWebkitBitrate();
        att.contentRenditionName = this.getRenditionName();
        att.contentRenditionBitrate = this.getRenditionBitrate();
        att.contentRenditionHeight = this.getRenditionHeight();
        att.contentRenditionWidth = this.getRenditionWidth();
        att.contentDuration = this.getDuration();
        att.contentPlayhead = this.getPlayhead();
        att.contentLanguage = this.getLanguage();
        att.contentSrc = this.getSrc();
        att.contentPlayrate = this.getPlayrate();
        att.contentIsFullscreen = this.isFullscreen();
        att.contentIsMuted = this.isMuted();
        att.contentCdn = this.getCdn();
        att.contentIsAutoplayed = this.isAutoplayed();
        att.contentPreload = this.getPreload();
        att.contentFps = this.getFps();
      }

      this.state.getStateAttributes(att);

      for (var key in this.customData) {
        att[key] = this.customData[key];
      }

      return att;
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendPlayerReady',
    value: function sendPlayerReady(att) {
      if (this.state.goPlayerReady()) {
        att = att || {};
        this.send(VideoTracker.Events.PLAYER_READY, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners. Calls
     * {@link startHeartbeat}.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendRequest',
    value: function sendRequest(att) {
      if (this.state.goRequest()) {
        this.state.goViewCountUp();
        var ev = this.isAd() ? VideoTracker.Events.AD_REQUEST : VideoTracker.Events.CONTENT_REQUEST;
        this.send(ev, att);
        this.startHeartbeat();
        this.state.goHeartbeat();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendStart',
    value: function sendStart(att) {
      if (this.state.goStart()) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_START;
          if (this.parentTracker) this.parentTracker.state.isPlaying = false;
        } else {
          ev = VideoTracker.Events.CONTENT_START;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners. Calls
     * {@link stopHeartbeat}.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendEnd',
    value: function sendEnd(att) {
      if (this.state.goEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_END;
          att.timeSinceAdRequested = this.state.timeSinceRequested.getDeltaTime();
          att.timeSinceAdStarted = this.state.timeSinceStarted.getDeltaTime();
          if (this.parentTracker) this.parentTracker.state.isPlaying = true;
        } else {
          ev = VideoTracker.Events.CONTENT_END;
          att.timeSinceRequested = this.state.timeSinceRequested.getDeltaTime();
          att.timeSinceStarted = this.state.timeSinceStarted.getDeltaTime();
        }
        this.stopHeartbeat();
        this.send(ev, att);
        if (this.parentTracker && this.isAd()) this.parentTracker.state.goLastAd();

        this.state.goViewCountUp();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendPause',
    value: function sendPause(att) {
      if (this.state.goPause()) {
        var ev = this.isAd() ? VideoTracker.Events.AD_PAUSE : VideoTracker.Events.CONTENT_PAUSE;
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendResume',
    value: function sendResume(att) {
      if (this.state.goResume()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_RESUME;
          att.timeSinceAdPaused = this.state.timeSincePaused.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_RESUME;
          att.timeSincePaused = this.state.timeSincePaused.getDeltaTime();
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendBufferStart',
    value: function sendBufferStart(att) {
      if (this.state.goBufferStart()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_BUFFER_START;
        } else {
          ev = VideoTracker.Events.CONTENT_BUFFER_START;
        }
        if (!this.state.isStarted) {
          att.isInitialBuffering = !this.state.initialBufferingHappened;
        } else {
          att.isInitialBuffering = false;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendBufferEnd',
    value: function sendBufferEnd(att) {
      if (this.state.goBufferEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_BUFFER_END;
          att.timeSinceAdBufferBegin = this.state.timeSinceBufferBegin.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_BUFFER_END;
          att.timeSinceBufferBegin = this.state.timeSinceBufferBegin.getDeltaTime();
        }
        if (!this.state.isStarted) {
          att.isInitialBuffering = !this.state.initialBufferingHappened;
        } else {
          att.isInitialBuffering = false;
        }
        this.send(ev, att);
        this.state.initialBufferingHappened = true;
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendSeekStart',
    value: function sendSeekStart(att) {
      if (this.state.goSeekStart()) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_SEEK_START;
        } else {
          ev = VideoTracker.Events.CONTENT_SEEK_START;
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendSeekEnd',
    value: function sendSeekEnd(att) {
      if (this.state.goSeekEnd()) {
        att = att || {};
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_SEEK_END;
          att.timeSinceAdSeekBegin = this.state.timeSinceSeekBegin.getDeltaTime();
        } else {
          ev = VideoTracker.Events.CONTENT_SEEK_END;
          att.timeSinceSeekBegin = this.state.timeSinceSeekBegin.getDeltaTime();
        }
        this.send(ev, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {String} att.state Download requires a string to distinguish different states.
     */

  }, {
    key: 'sendDownload',
    value: function sendDownload(att) {
      att = att || {};
      if (!att.state) _log2.default.warn('Called sendDownload without { state: xxxxx }.');
      this.send(VideoTracker.Events.DOWNLOAD, att);
      this.state.goDownload();
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendError',
    value: function sendError(att) {
      att = att || {};
      att.isAd = true;
      this.state.goError();
      var ev = this.isAd() ? VideoTracker.Events.AD_ERROR : VideoTracker.Events.CONTENT_ERROR;
      this.send(ev, att);
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendRenditionChanged',
    value: function sendRenditionChanged(att) {
      att = att || {};
      att.timeSinceLastRenditionChange = this.state.timeSinceLastRenditionChange.getDeltaTime();
      att.shift = this.getRenditionShift(true);
      var ev = void 0;
      if (this.isAd()) {
        ev = VideoTracker.Events.AD_RENDITION_CHANGE;
      } else {
        ev = VideoTracker.Events.CONTENT_RENDITION_CHANGE;
      }
      this.send(ev, att);
      this.state.goRenditionChange();
    }

    /**
     * Sends associated event and changes view state. Heartbeat will automatically be sent every
     * 10 seconds. There's no need to call this manually.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.url Url of the clicked ad.
     *
     */

  }, {
    key: 'sendHeartbeat',
    value: function sendHeartbeat(att) {
      if (this.state.isRequested) {
        var ev = void 0;
        if (this.isAd()) {
          ev = VideoTracker.Events.AD_HEARTBEAT;
        } else {
          ev = VideoTracker.Events.CONTENT_HEARTBEAT;
        }
        this.send(ev, att);
        this.state.goHeartbeat();
      }
    }

    // Only ads
    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendAdBreakStart',
    value: function sendAdBreakStart(att) {
      if (this.isAd() && this.state.goAdBreakStart()) {
        if (this.parentTracker) this.parentTracker.state.isPlaying = false;
        this.send(VideoTracker.Events.AD_BREAK_START, att);
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     */

  }, {
    key: 'sendAdBreakEnd',
    value: function sendAdBreakEnd(att) {
      if (this.isAd() && this.state.goAdBreakEnd()) {
        att = att || {};
        att.timeSinceAdBreakBegin = this.state.timeSinceAdBreakStart.getDeltaTime();
        this.send(VideoTracker.Events.AD_BREAK_END, att);
        // Just in case AD_END not arriving, because of an AD_ERROR
        if (this.parentTracker) this.parentTracker.state.isPlaying = true;
        this.stopHeartbeat();
        if (this.parentTracker && this.isAd()) this.parentTracker.state.goLastAd();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.quartile Number of the quartile.
     */

  }, {
    key: 'sendAdQuartile',
    value: function sendAdQuartile(att) {
      if (this.isAd()) {
        att = att || {};
        if (!att.quartile) _log2.default.warn('Called sendAdQuartile without { quartile: xxxxx }.');
        att.timeSinceLastAdQuartile = this.state.timeSinceLastAdQuartile.getDeltaTime();
        this.send(VideoTracker.Events.AD_QUARTILE, att);
        this.state.goAdQuartile();
      }
    }

    /**
     * Sends associated event and changes view state. An internal state machine will prevent
     * duplicated events. Should be associated to an event using registerListeners.
     * @param {Object} [att] Collection of key:value attributes to send with the request.
     * @param {number} att.url Url of the clicked ad.
     */

  }, {
    key: 'sendAdClick',
    value: function sendAdClick(att) {
      if (this.isAd()) {
        att = att || {};
        if (!att.url) _log2.default.warn('Called sendAdClick without { url: xxxxx }.');
        this.send(VideoTracker.Events.AD_CLICK, att);
      }
    }
  }]);

  return VideoTracker;
}(_tracker2.default);

/**
 * Enumeration of events fired by this class.
 *
 * @static
 * @memberof VideoTracker
 * @enum
 */


VideoTracker.Events = {
  // Player
  PLAYER_READY: 'PLAYER_READY',
  DOWNLOAD: 'DOWNLOAD',
  ERROR: 'ERROR',

  // Video
  CONTENT_REQUEST: 'CONTENT_REQUEST',
  CONTENT_START: 'CONTENT_START',
  CONTENT_END: 'CONTENT_END',
  CONTENT_PAUSE: 'CONTENT_PAUSE',
  CONTENT_RESUME: 'CONTENT_RESUME',
  CONTENT_SEEK_START: 'CONTENT_SEEK_START',
  CONTENT_SEEK_END: 'CONTENT_SEEK_END',
  CONTENT_BUFFER_START: 'CONTENT_BUFFER_START',
  CONTENT_BUFFER_END: 'CONTENT_BUFFER_END',
  CONTENT_HEARTBEAT: 'CONTENT_HEARTBEAT',
  CONTENT_RENDITION_CHANGE: 'CONTENT_RENDITION_CHANGE',
  CONTENT_ERROR: 'CONTENT_ERROR',

  // Ads only
  AD_REQUEST: 'AD_REQUEST',
  AD_START: 'AD_START',
  AD_END: 'AD_END',
  AD_PAUSE: 'AD_PAUSE',
  AD_RESUME: 'AD_RESUME',
  AD_SEEK_START: 'AD_SEEK_START',
  AD_SEEK_END: 'AD_SEEK_END',
  AD_BUFFER_START: 'AD_BUFFER_START',
  AD_BUFFER_END: 'AD_BUFFER_END',
  AD_HEARTBEAT: 'AD_HEARTBEAT',
  AD_RENDITION_CHANGE: 'AD_RENDITION_CHANGE',
  AD_ERROR: 'AD_ERROR',
  AD_BREAK_START: 'AD_BREAK_START',
  AD_BREAK_END: 'AD_BREAK_END',
  AD_QUARTILE: 'AD_QUARTILE',
  AD_CLICK: 'AD_CLICK'

  // Private members
};function funnelAdEvents(e) {
  this.send(e.type, e.data);
}

exports.default = VideoTracker;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreewheelAdsTracker = exports.BrightcoveImaAdsTracker = exports.ImaAdsTracker = exports.VideojsAdsTracker = exports.ShakaTech = exports.ContribHlsTech = exports.HlsJsTech = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newrelicVideoCore = __webpack_require__(0);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _package = __webpack_require__(8);

var _contribHls = __webpack_require__(14);

var _contribHls2 = _interopRequireDefault(_contribHls);

var _hlsJs = __webpack_require__(15);

var _hlsJs2 = _interopRequireDefault(_hlsJs);

var _shaka = __webpack_require__(16);

var _shaka2 = _interopRequireDefault(_shaka);

var _videojsAds = __webpack_require__(1);

var _videojsAds2 = _interopRequireDefault(_videojsAds);

var _ima = __webpack_require__(17);

var _ima2 = _interopRequireDefault(_ima);

var _brightcoveIma = __webpack_require__(18);

var _brightcoveIma2 = _interopRequireDefault(_brightcoveIma);

var _freewheel = __webpack_require__(19);

var _freewheel2 = _interopRequireDefault(_freewheel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideojsTracker = function (_nrvideo$VideoTracker) {
  _inherits(VideojsTracker, _nrvideo$VideoTracker);

  function VideojsTracker() {
    _classCallCheck(this, VideojsTracker);

    return _possibleConstructorReturn(this, (VideojsTracker.__proto__ || Object.getPrototypeOf(VideojsTracker)).apply(this, arguments));
  }

  _createClass(VideojsTracker, [{
    key: 'getTech',
    value: function getTech() {
      var tech = this.player.tech({ IWillNotUseThisInPlugins: true });
      if (tech) {
        if (_contribHls2.default.isUsing(tech)) {
          return new _contribHls2.default(tech);
        } else if (_hlsJs2.default.isUsing(tech)) {
          return new _hlsJs2.default(tech);
        } else if (_shaka2.default.isUsing(tech)) {
          return new _shaka2.default(tech);
        }
      }
    }
  }, {
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'videojs';
    }
  }, {
    key: 'getTrackerVersion',
    value: function getTrackerVersion() {
      return _package.version;
    }
  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      if (this.player.ads && this.player.ads.state === 'ads-playback' && this.player.ads.snapshot && this.player.ads.snapshot.currentTime) {
        return this.player.ads.snapshot.currentTime * 1000;
      } else if (this.player.absoluteTime) {
        return this.player.absoluteTime() * 1000;
      } else {
        return this.player.currentTime() * 1000;
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (this.player.mediainfo && typeof this.player.mediainfo.duration !== 'undefined') {
        return this.player.mediainfo.duration * 1000; // Brightcove
      } else {
        return this.player.duration() * 1000;
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      if (this.player.mediainfo) {
        return this.player.mediainfo.name; // Brightcove
      }
    }
  }, {
    key: 'getSrc',
    value: function getSrc() {
      var tech = this.getTech();
      if (tech && tech.getSrc) {
        return tech.getSrc();
      } else {
        return this.player.currentSrc();
      }
    }
  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return videojs.VERSION;
    }
  }, {
    key: 'isMuted',
    value: function isMuted() {
      return this.player.muted();
    }
  }, {
    key: 'getRenditionName',
    value: function getRenditionName() {
      var tech = this.getTech();
      if (tech && tech.getRenditionName) {
        return tech.getRenditionName();
      }
    }
  }, {
    key: 'getRenditionBitrate',
    value: function getRenditionBitrate() {
      var tech = this.getTech();
      if (tech && tech.getRenditionBitrate) {
        return tech.getRenditionBitrate();
      }
    }
  }, {
    key: 'getRenditionHeight',
    value: function getRenditionHeight() {
      var tech = this.getTech();
      if (tech && tech.getRenditionHeight) {
        return tech.getRenditionHeight();
      }
      return this.player.videoHeight();
    }
  }, {
    key: 'getRenditionWidth',
    value: function getRenditionWidth() {
      var tech = this.getTech();
      if (tech && tech.getRenditionWidth) {
        return tech.getRenditionWidth();
      }
      return this.player.videoWidth();
    }
  }, {
    key: 'getPlayrate',
    value: function getPlayrate() {
      return this.player.playbackRate();
    }
  }, {
    key: 'isAutoplayed',
    value: function isAutoplayed() {
      return this.player.autoplay();
    }
  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this.player.preload();
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      nrvideo.Log.debugCommonVideoEvents(this.player, ['adstart', 'adend', 'adskip', 'adsready', 'adserror', 'dispose']);

      this.player.on('loadstart', this.onDownload.bind(this));
      this.player.on('loadeddata', this.onDownload.bind(this));
      this.player.on('loadedmetadata', this.onDownload.bind(this));
      this.player.on('adsready', this.onAdsready.bind(this));
      this.player.on('play', this.onPlay.bind(this));
      this.player.on('pause', this.onPause.bind(this));
      this.player.on('playing', this.onPlaying.bind(this));
      this.player.on('abort', this.onAbort.bind(this));
      this.player.on('ended', this.onEnded.bind(this));
      this.player.on('dispose', this.onDispose.bind(this));
      this.player.on('seeking', this.onSeeking.bind(this));
      this.player.on('seeked', this.onSeeked.bind(this));
      this.player.on('error', this.onError.bind(this));
      this.player.on('waiting', this.onWaiting.bind(this));
      this.player.on('timeupdate', this.onTimeupdate.bind(this));
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      this.player.off('loadstart', this.onDownload);
      this.player.off('loadeddata', this.onDownload);
      this.player.off('loadedmetadata', this.onDownload);
      this.player.off('adsready', this.onAdsready);
      this.player.off('play', this.onPlay);
      this.player.off('pause', this.onPause);
      this.player.off('playing', this.onPlaying);
      this.player.off('abort', this.onAbort);
      this.player.off('ended', this.onEnded);
      this.player.off('dispose', this.onDispose);
      this.player.off('seeking', this.onSeeking);
      this.player.off('seeked', this.onSeeked);
      this.player.off('error', this.onError);
      this.player.off('waiting', this.onWaiting);
      this.player.off('timeupdate', this.onTimeupdate);
    }
  }, {
    key: 'onDownload',
    value: function onDownload(e) {
      this.sendDownload({ state: e.type });
    }
  }, {
    key: 'onAdsready',
    value: function onAdsready() {
      if (!this.adsTracker) {
        if (_brightcoveIma2.default.isUsing(this.player)) {
          // BC IMA
          this.setAdsTracker(new _brightcoveIma2.default(this.player));
        } else if (_ima2.default.isUsing(this.player)) {
          // IMA
          this.setAdsTracker(new _ima2.default(this.player));
        } else if (_freewheel2.default.isUsing(this.player)) {
          // FW
          this.setAdsTracker(new _freewheel2.default(this.player));
          // } else if (OnceAdsTracker.isUsing(this)) { // Once
        } else {
          // Generic
          this.setAdsTracker(new _videojsAds2.default(this.player));
        }
      }
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.sendRequest();
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.sendPause();
    }
  }, {
    key: 'onPlaying',
    value: function onPlaying() {
      this.sendResume();
      this.sendBufferEnd();
    }
  }, {
    key: 'onAbort',
    value: function onAbort() {
      this.sendEnd();
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      this.sendEnd();
    }
  }, {
    key: 'onDispose',
    value: function onDispose() {
      this.sendEnd();
    }
  }, {
    key: 'onSeeking',
    value: function onSeeking() {
      this.sendSeekStart();
    }
  }, {
    key: 'onSeeked',
    value: function onSeeked() {
      this.sendSeekEnd();
    }
  }, {
    key: 'onError',
    value: function onError() {
      if (this.player.error && this.player.error()) {
        this.sendError(this.player.error());
      }
    }
  }, {
    key: 'onWaiting',
    value: function onWaiting(e) {
      this.sendBufferStart();
    }
  }, {
    key: 'onTimeupdate',
    value: function onTimeupdate(e) {
      if (this.getPlayhead() > 0.1) {
        this.sendStart();
      }
    }
  }]);

  return VideojsTracker;
}(nrvideo.VideoTracker);

// Static members


exports.default = VideojsTracker;
exports.HlsJsTech = _hlsJs2.default;
exports.ContribHlsTech = _contribHls2.default;
exports.ShakaTech = _shaka2.default;
exports.VideojsAdsTracker = _videojsAds2.default;
exports.ImaAdsTracker = _ima2.default;
exports.BrightcoveImaAdsTracker = _brightcoveIma2.default;
exports.FreewheelAdsTracker = _freewheel2.default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContribHlsTech = function () {
  function ContribHlsTech(tech) {
    _classCallCheck(this, ContribHlsTech);

    this.tech = tech.hls;
  }

  _createClass(ContribHlsTech, [{
    key: "getRenditionName",
    value: function getRenditionName() {
      try {
        var media = this.tech.playlists.media();
        if (media && media.attributes) return media.attributes.NAME;
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionBitrate",
    value: function getRenditionBitrate() {
      try {
        var media = this.tech.playlists.media();
        if (media && media.attributes) return media.attributes.BANDWIDTH;
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionWidth",
    value: function getRenditionWidth() {
      try {
        var media = this.tech.playlists.media();
        if (media && media.attributes && media.attributes.RESOLUTION) {
          return media.attributes.RESOLUTION.width;
        }
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionHeight",
    value: function getRenditionHeight() {
      try {
        var media = this.tech.playlists.media();
        if (media && media.attributes && media.attributes.RESOLUTION) {
          return media.attributes.RESOLUTION.height;
        }
      } catch (err) {}
      return null;
    }
  }]);

  return ContribHlsTech;
}();

exports.default = ContribHlsTech;


ContribHlsTech.isUsing = function (tech) {
  return !!tech.hls;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HlsJs = function () {
  function HlsJs(tech) {
    _classCallCheck(this, HlsJs);

    this.tech = tech.hls_;
  }

  _createClass(HlsJs, [{
    key: "getResource",
    value: function getResource(tech) {
      return this.tech.url;
    }
  }, {
    key: "getRenditionName",
    value: function getRenditionName(tech) {
      try {
        var level = this.tech.levels[this.tech.currentLevel];
        if (level && level.name) return level.name;
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionBitrate",
    value: function getRenditionBitrate(tech) {
      try {
        var level = this.tech.levels[this.tech.currentLevel];
        if (level && level.bitrate) return level.bitrate;
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionWidth",
    value: function getRenditionWidth(tech) {
      try {
        var level = this.tech.levels[this.tech.currentLevel];
        if (level && level.width) return level.width;
      } catch (err) {}
      return null;
    }
  }, {
    key: "getRenditionHeight",
    value: function getRenditionHeight(tech) {
      try {
        var level = this.tech.levels[this.tech.currentLevel];
        if (level && level.height) return level.height;
      } catch (err) {}
      return null;
    }
  }]);

  return HlsJs;
}();

exports.default = HlsJs;


HlsJs.isUsing = function (tech) {
  return !!tech.hls_;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShakaTech = function () {
  function ShakaTech(tech) {
    _classCallCheck(this, ShakaTech);

    this.tech = tech.shakaPlayer;
  }

  _createClass(ShakaTech, [{
    key: 'getSrc',
    value: function getSrc(tech) {
      try {
        return this.tech.getManifestUri();
      } catch (err) {}
      return null;
    }
  }, {
    key: 'getRenditionBitrate',
    value: function getRenditionBitrate(tech) {
      try {
        return this.tech.getStats().streamBandwidth;
      } catch (err) {}
      return null;
    }
  }, {
    key: 'getRenditionWidth',
    value: function getRenditionWidth(tech) {
      try {
        var tracks = this.tech.getVariantTracks();
        for (var i in tracks) {
          var track = tracks[i];
          if (track.active && track.type === 'video') {
            return track.width;
          }
        }
      } catch (err) {}
      return null;
    }
  }, {
    key: 'getRenditionHeight',
    value: function getRenditionHeight(tech) {
      try {
        var tracks = this.tech.getVariantTracks();
        for (var i in tracks) {
          var track = tracks[i];
          if (track.active && track.type === 'video') {
            return track.height;
          }
        }
      } catch (err) {}
      return null;
    }
  }]);

  return ShakaTech;
}();

exports.default = ShakaTech;


ShakaTech.isUsing = function (tech) {
  return !!tech.shakaPlayer;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newrelicVideoCore = __webpack_require__(0);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _videojsAds = __webpack_require__(1);

var _videojsAds2 = _interopRequireDefault(_videojsAds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global google */


var ImaAdsTracker = function (_VideojsAdsTracker) {
  _inherits(ImaAdsTracker, _VideojsAdsTracker);

  function ImaAdsTracker() {
    _classCallCheck(this, ImaAdsTracker);

    return _possibleConstructorReturn(this, (ImaAdsTracker.__proto__ || Object.getPrototypeOf(ImaAdsTracker)).apply(this, arguments));
  }

  _createClass(ImaAdsTracker, [{
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'ima-ads';
    }
  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return 'ima';
    }
  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return 'ima: ' + google.ima.VERSION + '; contrib-ads: ' + this.player.ads.VERSION;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      try {
        return this.player.ima.getAdsManager().getCurrentAd().getDuration() * 1000;
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getVideoId',
    value: function getVideoId() {
      try {
        return this.player.ima.getAdsManager().getCurrentAd().getAdId();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getAdCreativeId',
    value: function getAdCreativeId() {
      try {
        return this.player.ima.getAdsManager().getCurrentAd().getCreativeId();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getSrc',
    value: function getSrc() {
      try {
        return this.player.ima.getAdsManager().getCurrentAd().getMediaUrl();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      try {
        return this.player.ima.getAdsManager().getCurrentAd().getTitle();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      var manager = this.player.ima.getAdsManager();
      if (manager) {
        return (this.getDuration() - manager.getRemainingTime()) * 1000;
      }
    }
  }, {
    key: 'getPlayrate',
    value: function getPlayrate() {
      return this.player.playbackRate();
    }
  }, {
    key: 'getAdPartner',
    value: function getAdPartner() {
      return 'ima';
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      // Shortcut events
      var e = google.ima.AdEvent.Type;
      var AD_ERROR = google.ima.AdErrorEvent.Type.AD_ERROR;

      // debug
      nrvideo.Log.debugCommonVideoEvents(this.player.ima.addEventListener, [null, e.ALL_ADS_COMPLETED, e.LINEAR_CHANGED, e.COMPLETE, e.USER_CLOSE, e.IMPRESSION, e.CONTENT_PAUSE_REQUESTED, e.CONTENT_RESUME_REQUESTED, e.SKIPPED, e.SKIPPABLE_STATE_CHANGED, e.LOADED, e.PAUSED, e.RESUMED, e.STARTED, e.AD_CAN_PLAY, e.AD_METADATA, e.EXPANDED_CHANGED, e.AD_BREAK_READY, e.LOG, e.CLICK, e.FIRST_QUARTILE, e.MIDPOINT, e.THIRD_QUARTILE, AD_ERROR]);

      // Register listeners
      this.player.ima.addEventListener(e.LOADED, this.onLoaded.bind(this));
      this.player.ima.addEventListener(e.IMPRESSION, this.onImpression.bind(this));
      this.player.ima.addEventListener(e.PAUSED, this.onPaused.bind(this));
      this.player.ima.addEventListener(e.RESUMED, this.onResumed.bind(this));
      this.player.ima.addEventListener(e.COMPLETE, this.onComplete.bind(this));
      this.player.ima.addEventListener(e.SKIPPED, this.onSkipped.bind(this));
      this.player.ima.addEventListener(e.CLICK, this.onClick.bind(this));
      this.player.ima.addEventListener(e.FIRST_QUARTILE, this.onFirstQuartile.bind(this));
      this.player.ima.addEventListener(e.MIDPOINT, this.onMidpoint.bind(this));
      this.player.ima.addEventListener(e.THIRD_QUARTILE, this.onThirdQuartile.bind(this));
      this.player.ima.addEventListener(AD_ERROR, this.onError.bind(this));
      this.player.on('adend', this.onAdend.bind(this));
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      // Shortcut events
      var e = google.ima.AdEvent.Type;
      var AD_ERROR = google.ima.AdErrorEvent.Type.AD_ERROR;

      // unregister listeners
      this.player.ima.removeEventListener(e.LOADED, this.onLoaded);
      this.player.ima.removeEventListener(e.IMPRESSION, this.onImpression);
      this.player.ima.removeEventListener(e.PAUSED, this.onPaused);
      this.player.ima.removeEventListener(e.RESUMED, this.onResumed);
      this.player.ima.removeEventListener(e.COMPLETE, this.onComplete);
      this.player.ima.removeEventListener(e.SKIPPED, this.onSkipped);
      this.player.ima.removeEventListener(e.CLICK, this.onClick);
      this.player.ima.removeEventListener(e.FIRST_QUARTILE, this.onFirstQuartile);
      this.player.ima.removeEventListener(e.MIDPOINT, this.onMidpoint);
      this.player.ima.removeEventListener(e.THIRD_QUARTILE, this.onThirdQuartile);
      this.player.ima.removeEventListener(AD_ERROR, this.onError);
      this.player.off('adend', this.onAdend);
    }
  }, {
    key: 'onLoaded',
    value: function onLoaded(e) {
      this.sendRequest();
    }
  }, {
    key: 'onImpression',
    value: function onImpression(e) {
      this.sendStart();
    }
  }, {
    key: 'onComplete',
    value: function onComplete(e) {
      this.sendEnd();
    }
  }, {
    key: 'onAdend',
    value: function onAdend(e) {
      this.sendEnd();
    }
  }, {
    key: 'onSkipped',
    value: function onSkipped(e) {
      this.sendEnd({ skipped: true });
    }
  }, {
    key: 'onError',
    value: function onError(e) {
      this.sendError(e.getError());
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      this.sendAdClick();
    }
  }, {
    key: 'onFirstQuartile',
    value: function onFirstQuartile() {
      this.sendAdQuartile({ quartile: 1 });
    }
  }, {
    key: 'onMidpoint',
    value: function onMidpoint() {
      this.sendAdQuartile({ quartile: 2 });
    }
  }, {
    key: 'onThirdQuartile',
    value: function onThirdQuartile() {
      this.sendAdQuartile({ quartile: 3 });
    }
  }, {
    key: 'onPaused',
    value: function onPaused() {
      this.sendPause();
    }
  }, {
    key: 'onResumed',
    value: function onResumed() {
      this.sendResume();
    }
  }], [{
    key: 'isUsing',
    value: function isUsing(player) {
      return player.ima && typeof google !== 'undefined';
    }
  }]);

  return ImaAdsTracker;
}(_videojsAds2.default);

exports.default = ImaAdsTracker;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newrelicVideoCore = __webpack_require__(0);

var nrvideo = _interopRequireWildcard(_newrelicVideoCore);

var _videojsAds = __webpack_require__(1);

var _videojsAds2 = _interopRequireDefault(_videojsAds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BrightcoveImaAdsTracker = function (_VideojsAdsTracker) {
  _inherits(BrightcoveImaAdsTracker, _VideojsAdsTracker);

  function BrightcoveImaAdsTracker() {
    _classCallCheck(this, BrightcoveImaAdsTracker);

    return _possibleConstructorReturn(this, (BrightcoveImaAdsTracker.__proto__ || Object.getPrototypeOf(BrightcoveImaAdsTracker)).apply(this, arguments));
  }

  _createClass(BrightcoveImaAdsTracker, [{
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'brightcove-ima-ads';
    }
  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return 'brightcove-ima-ads';
    }
  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      return this.player.ima3.adPlayer.currentTime();
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      nrvideo.Log.debugCommonVideoEvents(this.player, [null, 'ima3-ready', 'ima3error', 'ima3-ad-error', 'ima3-started', 'ima3-complete', 'ima3-paused', 'ima3-resumed', 'ads-request', 'ads-load', 'ads-ad-started', 'ads-ad-ended', 'ads-pause', 'ads-play', 'ads-click', 'ads-pod-started', 'ads-pod-ended', 'ads-allpods-completed']);

      this.player.on('ima3-started', this.onStarted.bind(this));
      this.player.on('ima3-paused', this.onPaused.bind(this));
      this.player.on('ima3-resumed', this.onResume.bind(this));
      this.player.on('ima3-complete', this.onComplete.bind(this));
      this.player.on('ima3-skipped', this.onSkipped.bind(this));
      this.player.on('adserror', this.onError.bind(this));
      this.player.on('ads-click', this.onClick.bind(this));
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      this.player.off('ima3-started', this.onStarted);
      this.player.off('ima3-paused', this.onPaused);
      this.player.off('ima3-resumed', this.onResume);
      this.player.off('ima3-complete', this.onComplete);
      this.player.off('ima3-skipped', this.onSkipped);
      this.player.off('adserror', this.onError);
      this.player.off('ads-click', this.onClick);
    }
  }, {
    key: 'onStarted',
    value: function onStarted(e) {
      this.sendRequest();
      this.sendStart();
    }
  }, {
    key: 'onPaused',
    value: function onPaused(e) {
      this.sendPause();
    }
  }, {
    key: 'onResume',
    value: function onResume(e) {
      this.sendResume();
    }
  }, {
    key: 'onComplete',
    value: function onComplete(e) {
      this.sendEnd();
    }
  }, {
    key: 'onSkipped',
    value: function onSkipped(e) {
      this.sendEnd({ skipped: true });
    }
  }, {
    key: 'onError',
    value: function onError(e) {
      this.sendError();
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      this.sendClick();
    }
  }], [{
    key: 'isUsing',
    value: function isUsing(player) {
      return !!player.ima3;
    }
  }]);

  return BrightcoveImaAdsTracker;
}(_videojsAds2.default);

exports.default = BrightcoveImaAdsTracker;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _videojsAds = __webpack_require__(1);

var _videojsAds2 = _interopRequireDefault(_videojsAds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FreewheelAdsTracker = function (_VideojsAdsTracker) {
  _inherits(FreewheelAdsTracker, _VideojsAdsTracker);

  function FreewheelAdsTracker() {
    _classCallCheck(this, FreewheelAdsTracker);

    return _possibleConstructorReturn(this, (FreewheelAdsTracker.__proto__ || Object.getPrototypeOf(FreewheelAdsTracker)).apply(this, arguments));
  }

  _createClass(FreewheelAdsTracker, [{
    key: 'getTrackerName',
    value: function getTrackerName() {
      return 'freewheel-ads';
    }
  }, {
    key: 'getPlayerName',
    value: function getPlayerName() {
      return 'freewheel-ads';
    }
  }, {
    key: 'getPlayerVersion',
    value: function getPlayerVersion() {
      return this.player.FreeWheelPlugin.VERSION;
    }
  }, {
    key: 'getPlayhead',
    value: function getPlayhead() {
      if (this.player.ads.ad.currentTime) {
        return this.player.ads.ad.currentTime() * 1000;
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (this.player.ads.ad.duration) {
        return this.player.ads.ad.duration * 1000;
      }
    }
  }, {
    key: 'getVideoId',
    value: function getVideoId() {
      return this.player.ads.ad.id;
    }
  }, {
    key: 'getAdPartner',
    value: function getAdPartner() {
      return 'freewheel';
    }
  }, {
    key: 'getAdCreativeId',
    value: function getAdCreativeId() {
      try {
        return this.player.ads.provider.event.adInstance.getActiveCreativeRendition().getId();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getSrc',
    value: function getSrc() {
      try {
        var acr = this.player.ads.provider.event.adInstance.getActiveCreativeRendition();
        return acr.getPrimaryCreativeRenditionAsset().getUrl();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      try {
        var acr = this.player.ads.provider.event.adInstance.getActiveCreativeRendition();
        return acr.getPrimaryCreativeRenditionAsset().getName();
      } catch (err) {/* do nothing */}
    }
  }, {
    key: 'getAdPosition',
    value: function getAdPosition() {
      switch (this.player.ads.ad.type) {
        case 'PREROLL':
          return nrvideo.Constants.AdPositions.PRE;
        case 'MIDROLL':
          return nrvideo.Constants.AdPositions.MID;
        case 'POSTROLL':
          return nrvideo.Constants.AdPositions.POST;
      }
    }
  }], [{
    key: 'isUsing',
    value: function isUsing(player) {
      return !!player.FreeWheelPlugin && typeof tv !== 'undefined' && tv.freewheel;
    }
  }]);

  return FreewheelAdsTracker;
}(_videojsAds2.default);

exports.default = FreewheelAdsTracker;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof videojs !== 'undefined') {
  // Cross-compatibility for Video.js 5 and 6.
  var registerPlugin = videojs.registerPlugin || videojs.plugin;

  /**
   * Register newrelic's video.js plugin.
   *
   * In the plugin function, the value of `this` is a video.js `Player`
   * instance. You cannot rely on the player being in a "ready" state here,
   * depending on how the plugin is invoked. This may or may not be important
   * to you; if not, remove the wait for "ready"!
   */
  registerPlugin('newrelic', function (options) {
    if (!this.newrelictracker) {
      this.newrelictracker = new nrvideo.VideojsTracker(this);
      nrvideo.Core.addTracker(this.newrelictracker);
    }
    return this.newrelictracker;
  });
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// newrelic-video-videojs.min.js